<template>
  <div class="checksum-group">
    <div v-if="c4"><small><strong>c4: </strong></small><small>{{c4}}</small></div>
    <div v-if="crc32"><small><strong>crc32: </strong></small><small>{{crc32}}</small></div>
    <div v-if="md5"><small><strong>md5: </strong></small><small>{{md5}}</small></div>
    <div v-if="sha1"><small><strong>sha1: </strong></small><small>{{sha1}}</small></div>
    <div v-if="sha2256"><small><strong>sha2256: </strong></small><small>{{sha2256}}</small></div>
    <div v-if="sha2512"><small><strong>sha2512: </strong></small><small>{{sha2512}}</small></div>
    <div v-if="srSum"><small><strong>srSum: </strong></small><small>{{srSum}}</small></div>
    <div v-if="xxhash64"><small><strong>xxhash64: </strong></small><small>{{xxhash64}}</small></div>
    <div v-if="xxhash364"><small><strong>xxhash364: </strong></small><small>{{xxhash364}}</small></div>
    <div v-if="xxhash3128"><small><strong>xxhash3128: </strong></small><small>{{xxhash3128}}</small></div>
  </div>
</template>

<script>
export default {
  name: 'ChecksumList',
  props: {
    checksums: {
      type: Object,
      required: true,
    },
  },
  computed: {
    c4() {
      return this.checksums.c4 !== '' ? this.checksums.c4 : undefined;
    },
    crc32() {
      return this.checksums.crc32 !== '' ? this.checksums.crc32 : undefined;
    },
    md5() {
      return this.checksums.md5 !== '' ? this.checksums.md5 : undefined;
    },
    sha1() {
      return this.checksums.sha1 !== '' ? this.checksums.sha1 : undefined;
    },
    sha2256() {
      return this.checksums.sha2256 !== '' ? this.checksums.sha2256 : undefined;
    },
    sha2512() {
      return this.checksums.sha2512 !== '' ? this.checksums.sha2512 : undefined;
    },
    srSum() {
      return this.checksums.srSum !== '' ? this.checksums.srSum : undefined;
    },
    xxhash64() {
      return this.checksums.xxhash64 !== '' ? this.checksums.xxhash64 : undefined;
    },
    xxhash364() {
      return this.checksums.xxhash364 !== '' ? this.checksums.xxhash364 : undefined;
    },
    xxhash3128() {
      return this.checksums.xxhash3128 !== '' ? this.checksums.xxhash3128 : undefined;
    },
  },
};
</script>

<style scoped>
.checksum-group {
  width: 80%;
}
</style>
